import { Box, withStyles } from '@material-ui/core';
import React, { useMemo, useState } from 'react';

import styles from '../../../../../../../src/styles/modals.module.scss';
import Button from '../../../../../../components/Buttons/Button';
import Modal from '../../../../../../components/Modals/Modal';
import TextInput from '../../../../../../components/Inputs/TextInput';
import PhoneInput from '../../../../../../components/Inputs/PhoneInput';

import {
  emailVerification,
  phonenumberVerification,
  textVerification,
} from '../../../../../../utils/formValdations';
import Typography from '../../../../../../components/Typography/Typography';
import FlexColumn from '../../../../../../components/FlexBox/FlexColumn';
import FlexRow from '../../../../../../components/FlexBox/FlexRow';
import SDialog from '../../../../../../components/SDialog/SDialog';

const errorText = 'Please enter a valid';

const NewAdminPopup = ({ showModal, closeModal, onClick }) => {
  const [adminName, setAdminName] = useState({ value: '', error: '' });
  const [adminEmail, setAdminEmail] = useState({ value: '', error: '' });
  const [adminPhoneNumber, setAdminPhoneNumber] = useState({ value: '', error: '' });
  const [countryCode, setCountryCode] = useState('91');

  const WhiteTextTypography = withStyles({
    root: {
      color: '#483f94',
    },
  })(Typography);

  const boxStyle = {
    // border: '1px solid #D3D3D3',
    // borderRadius: '8px',
    padding: '20px',
    // marginTop: '12px',
  };

  const handleClick = () => {
    const phoneNumber = `+${countryCode}${adminPhoneNumber.value}`;
    const payload = {
      name: adminName.value,
      phone: phoneNumber,
      email: adminEmail.value,
      adminType: 2,
    };
    onClick(payload);
    closeModal();
  };

  const handleChange = (e) => {
    const { name, value } = e?.currentTarget;

    let error = '';
    switch (name) {
      case 'adminName':
        error = textVerification(value, 2) ? `${errorText} admin name` : '';
        setAdminName({ value, error });
        break;
      case 'adminEmail':
        error = !emailVerification(value) ? `${errorText} admin email` : '';
        setAdminEmail({ value, error });
        break;
      case 'adminPhoneNumber':
        error = !phonenumberVerification(`+${countryCode}${value}`)
          ? `${errorText} phone number`
          : '';
        setAdminPhoneNumber({ value, error });
        break;

      default:
        break;
    }
  };

  const disabled = useMemo(() => {
    if (adminEmail.value === '' || adminName.value === '' || adminPhoneNumber.value === '') {
      return true;
    }
    if (adminEmail.error !== '' || adminName.error !== '' || adminPhoneNumber.error !== '') {
      return true;
    }
    return false;
  }, [adminEmail, adminName, adminPhoneNumber]);

  return (
    <SDialog
      title='Add super admin details'
      open={showModal}
      onClose={closeModal}
      titleConfig={{
        variant: 'h5M'
      }}
      isFormDialog={true}
      secondaryButtonConfig={{
        text: 'Cancel',
        onClick: closeModal
      }}
      primaryButtonConfig={{
        text: 'Add',
        onClick: handleClick,
        disabled: disabled
      }}
    >
      <FlexColumn alignItems='start'>
        <Typography variant={"b2R"} color='var(--info-900)'>Enter super admin details. Initiate handover once user signs up</Typography>
        <TextInput
          name="adminName"
          placeholder="Admin Name"
          value={adminName.value}
          onChange={handleChange}
          disabled={false}
          error={adminName.error}
        />
        <PhoneInput
          name="adminPhoneNumber"
          placeholder="Admin Phone Number"
          type="number"
          defaultCountryCode={countryCode}
          value={adminPhoneNumber.value}
          onChange={handleChange}
          disabled={false}
          error={adminPhoneNumber.error}
          handleCountryCode={(code) => setCountryCode(code)}
        />
        <TextInput
          name="adminEmail"
          placeholder="Admin Email Address"
          type="email"
          value={adminEmail.value}
          onChange={handleChange}
          disabled={false}
          error={adminEmail.error}
        />
      </FlexColumn>
    </SDialog>
  );
};

export default NewAdminPopup;
